import React, { Component } from 'react';
import { Button } from 'reactstrap';

class ReadText extends Component {
  render() {
    return (
      <div className="Step ReadText">
        {this.props.headline && (<h1>{this.props.headline}</h1>)}
        {this.props.description && <div dangerouslySetInnerHTML={this.props.createMarkup(this.props.description)} />}
        {this.props.buttonNext &&
          (<Button color="primary" className="float-right" onClick={this.props.advanceStep}>{this.props.buttonNext}</Button>)
        }
      </div>
    );
  }
}

export default ReadText;



// WEBPACK FOOTER //
// ./src/ReadText.js